import React from 'react';
import {
  Box, Tabs, TabList, TabPanels, Tab, TabPanel, Heading, Text, VStack
} from "@chakra-ui/react";
import UnifiedUserImporter from './UnifiedUserImporter';
import RoleImporter from './RoleImporter';
import BecadosImporter from '../Suscriptions/components/BecadosImporter';
import AvatarImporter from '../Suscriptions/components/AvatarImporter';

const ImportUsersPage = () => {
  return (
    <Box px={{ base: 4, md: 6 }} py={6}>
      <VStack spacing={2} mb={6} align="start">
        <Heading size="lg">Importacion de Alumnos</Heading>
        <Text color="gray.500" fontSize="sm">
          Usa las pestanas para actualizar informacion o sincronizar roles de forma independiente.
        </Text>
      </VStack>

      <Tabs colorScheme="teal" variant="enclosed">
        <TabList>
          <Tab fontWeight="semibold">Actualizar Informacion</Tab>
          <Tab fontWeight="semibold">Sincronizar Roles</Tab>
          <Tab fontWeight="semibold">Becados</Tab>
          <Tab fontWeight="semibold">Fotos de Perfil</Tab>
        </TabList>

        <TabPanels>
          <TabPanel px={0} pt={4}>
            <UnifiedUserImporter />
          </TabPanel>
          <TabPanel px={0} pt={4}>
            <RoleImporter />
          </TabPanel>
          <TabPanel px={0} pt={4}>
            <BecadosImporter />
          </TabPanel>
          <TabPanel px={0} pt={4}>
            <AvatarImporter />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default ImportUsersPage;
